import store from '@/store'

export default async function useStatisticsRouteFetch() {
  return store.dispatch('chart/fetchStatisticRoute', {
    demandType: store.getters['chart/getDemandType'],
  })
}
